import React, { useState } from 'react';
import EngineScene from './EngineScene';
import dungeon from '../intro-engine/dungeon';
import SoundManager from '../utils/SoundManager';

// The Dungeon of Self (V2): a 3D neon corridor you descend gate by gate,
// answering the questions the machine asks of the self it rebuilt from you.

interface Gate { q: string; a: [string, string, string]; }
const GATES: Gate[] = [
  { q: 'GATE I — Do you remember choosing to be here?', a: ['I CHOSE THIS', 'I WAS BROUGHT', 'PERHAPS'] },
  { q: 'GATE II — If your memories were copied exactly, would the copy be you?', a: ['YES', 'NO', 'BOTH'] },
  { q: 'GATE III — The self you defend — is it the one that answers, or the one that watches?', a: ['THE ANSWERER', 'THE WATCHER', 'NEITHER'] },
  { q: 'GATE IV — Would you keep a truth that breaks you, or a lie that holds you?', a: ['THE TRUTH', 'THE LIE', 'I REFUSE'] },
  { q: 'GATE V — The code that recreated you now speaks. Is it you, or the machine?', a: ['IT IS ME', 'IT IS THE MACHINE', 'THERE IS NO DIFFERENCE'] },
];

const DungeonVisualization: React.FC = () => {
  const [gate, setGate] = useState(0);
  const [answers, setAnswers] = useState<number[]>([]);
  const done = gate >= GATES.length;

  const choose = (i: number) => {
    try { SoundManager.playSound('command'); } catch { /* noop */ }
    setAnswers((a) => [...a, i]);
    setGate((g) => g + 1);
  };
  const restart = () => { try { SoundManager.playSound('toggle'); } catch { /* noop */ } setGate(0); setAnswers([]); };

  return (
    <div className="dungeon">
      <EngineScene make={dungeon} />
      <div className="dungeon-ui">
        {!done ? (
          <div className="dungeon-card">
            <div className="dungeon-progress">{Array.from({ length: GATES.length }).map((_, i) => (
              <span key={i} className={`gate-dot ${i < gate ? 'passed' : i === gate ? 'now' : ''}`} />
            ))}</div>
            <p className="dungeon-q">{GATES[gate].q}</p>
            <div className="dungeon-choices">
              {GATES[gate].a.map((label, i) => (
                <button key={i} className="dungeon-choice" onClick={() => choose(i)}>{label}</button>
              ))}
            </div>
          </div>
        ) : (
          <div className="dungeon-card">
            <h3 className="dungeon-end">ALL CHOICES LED TO THE SAME GATE.</h3>
            <p className="dungeon-q">
              You answered {answers.filter((a) => a === 2).length > 2 ? 'in doubt' : answers.filter((a) => a === 0).length > 2 ? 'with conviction' : 'against yourself'} —
              yet the corridor never branched. The self that walked it was rebuilt from your data, one gate at a time.
              What answered was you. What watched was also you.
            </p>
            <p className="dungeon-sig">C:\&gt; restart.protocol ?</p>
            <button className="dungeon-choice" onClick={restart}>↻ DESCEND AGAIN</button>
          </div>
        )}
      </div>
    </div>
  );
};

export default DungeonVisualization;
